import {useIsFetching, useIsMutating} from '@tanstack/react-query'
import {ReactNode} from 'react'
import {Spinner} from './Spinner'

type Props = {
  children: ReactNode
  className?: string
}

export const Page = ({children, className}: Props) => {
  const isMutating = useIsMutating()
  const isFetching = useIsFetching()
  const isLoading = isMutating + isFetching > 0

  return (
    <div className={className}>
      {children}
      {isLoading && <Spinner />}
    </div>
  )
}
